


























































import { Component,Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";
import { GapStatusSummaryReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class LogDateFilter extends Vue {
 @Model("change") readonly filter!: GapStatusSummaryReportFilter;
  id = "log-date-filter-popover";
  target = "log-date-filter-target";
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }

  setToday() {
    const today = new Date();
    this.filter.logDate.from = today;
    this.filter.logDate.to = today;
    this.search();
  }

  search() {
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.filter.logDate = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {

  }
}
